// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const prepareFilters = (columns: any) =>
  columns
    // eslint-disable-next-line no-prototype-builtins
    .filter((column) => column.hasOwnProperty('filterType'))
    .map((column) => {
      return {
        filterType: column.filterType,
        id: column.accessor,
        name: column.Header,
      }
    })
